export interface ResourceInsight {
  id: string
  resourceId: string
  resourceName: string
  resourceType: string
  compartmentName?: string | null
  region?: string | null
  reason: string
  consoleUrl?: string | null
  currencyCode: string
  monthlyEstimatedSavings?: number | null
  monthlyBillPercentage?: number | null
  currentOcpuCount?: number | null
  currentShape?: string | null
  recommendedOcpuCount?: number | null
  recommendedShape?: string | null
  versioningEnabled?: boolean | null
  resourceState?: string | null
  recommendationLevel?: string | null
  aggregationIntervalDays?: number | null
}

export interface Recommendation {
  id: string
  name: string
  description: string
  importance: string
  status: string
  currencyCode: string
  monthlyEstimatedSavings: number
  timeUpdated?: string | null
  resources?: ResourceInsight[]
}

export const USD_TO_KRW = 1445.3692

export const convertSavingsToKrwMinor = (
  amount?: number | null,
  currencyCode = 'KRW',
): number | null => {
  if (amount === null || amount === undefined || !Number.isFinite(amount)) return null
  const krwAmount = currencyCode.toUpperCase() === 'USD' ? amount * USD_TO_KRW : amount
  return Math.round(krwAmount * 100)
}

export const getResourceKrwMinorAmounts = (recommendation: Recommendation) =>
  (recommendation.resources ?? []).map((resource) =>
    convertSavingsToKrwMinor(
      resource.monthlyEstimatedSavings,
      resource.currencyCode || recommendation.currencyCode,
    ),
  )

export const getRecommendationKrwMinor = (recommendation: Recommendation) => {
  const resourceAmounts = getResourceKrwMinorAmounts(recommendation)
  if (resourceAmounts.length > 0 && resourceAmounts.every((amount) => amount !== null)) {
    return resourceAmounts.reduce<number>((total, amount) => total + (amount ?? 0), 0)
  }

  return convertSavingsToKrwMinor(
    recommendation.monthlyEstimatedSavings,
    recommendation.currencyCode,
  ) ?? 0
}

export const getTotalKrwMinor = (recommendations: Recommendation[]) =>
  recommendations.reduce(
    (total, recommendation) => total + getRecommendationKrwMinor(recommendation),
    0,
  )
